export const DIGITAL_TYPE = 1;
export const PHYSICALLY_TYPE = 2;
export const DIGITAL_PHYSICALLY_TYPE = 3;